import { Navigate } from "react-router-dom";

export interface LoginPageProps {}
export const LoginPage = ({}: LoginPageProps) => {
    return <Navigate to="/" />;
};
